import RSService from '@/api/recruitingSearch.service'
import jobManagementService from '@/api/job-management.service'

const actions = {
  searchCandidates(context, query) {
    return new Promise((resolve, reject) => {
      RSService.searchCandidates(query)
        .then(res => {
          console.log('RESULT:', res)
          if (res.data.TotalCount.length && res.data.SearchedResult.length) {
            context.commit('setNoResult', false)
            context.commit('updateResultCount', res.data.TotalCount[0].count)
            context.commit('updateResults', res.data.SearchedResult )
            context.commit('setPageCount', Math.ceil(res.data.TotalCount[0].count / 10))
          } else {
            context.commit('setNoResult', true)
          }
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  performLike(context, email) {
    return new Promise((resolve, reject) => {
      RSService.performLike(email)
        .then(res => {
          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  performDislike(context, email) {
    return new Promise((resolve, reject) => {
      RSService.performDislike(email)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  getFavorites(context) {
    return new Promise((resolve, reject) => {
      RSService.getFavorites()
        .then(res => {
          console.log('list', res.data)
          let favList = []
          res.data.forEach(can => {
            favList.push(can.candidateEmail)
          })
          context.commit('setFavorites', favList)
          context.commit('setFavoriteCandidatesAndMutate', res.data)
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  getRecJobCodes(context) {
    return new Promise((resolve, reject) => {
      jobManagementService
        .getActiveList()
        .then(res => {
          let jobcodes = []
          res.forEach(job => {
            if (job.JobCode.length > 0 && job.JobCode[0]) {
              jobcodes.push(job)
            }
          })
          context.commit('setRecJobCodes', jobcodes)
          resolve(jobcodes)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  createSubscription(context, data) {
    return new Promise((resolve, reject) => {
      RSService.createSubscription(context, data)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  updateSubscription(context, data) {
    return new Promise((resolve, reject) => {
      RSService.updateSubscription(context, data)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  cancelSubscription(context, data) {
    return new Promise((resolve, reject) => {
      RSService.cancelSubscription(context, data)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  suspendSubscription(context, data) {
    return new Promise((resolve, reject) => {
      RSService.suspendSubscription(context, data)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  verifyVoucher(context, data) {
    return new Promise((resolve, reject) => {
      RSService.verifyVoucher(context, data)
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  fetchSubscriptionDetail(context, data) {
    return new Promise((resolve, reject) => {
      RSService.fetchSubscriptionDetail(context, data)
        .then(res => {
          context.commit('subscriptionDetail', res)
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
}

export default actions
